// import "./m4q.js"
import {$} from "m4q"

globalThis.$ = $
globalThis.m4q = $
